export default {
  lat: 45.776272,
  lng: 15.97635,
}
